import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DomainName, STATUS } from "../../../Constants";
import axios from "axios";


// For Get The Next Page 
const getNextPostsEndpoint  = (args)=>`${DomainName}/page/post?userAccessToken=${args.userToken}&pageId=${args.pageId}&pagingToken=${args.hasNext}` ; 

 export const getNextPostsAPI = createAsyncThunk('searchPage/hasNextSearch' , async (args , thunkaPI)=>{
    const {rejectWithValue} = thunkaPI ; 
    try{
        const response = await axios.get(getNextPostsEndpoint(args) , {
            headers : {
                token :args.token
            }
        })
        return response.data ; 
    }catch(err){
        return rejectWithValue(err) ;
    }
})

// For Get Comments Of Post
const getAllCommentsOfPostEndPoint = (args)=>`${DomainName}/page/comments?userAccessToken=${args.userToken}&postId=${args.postId}` ;

export const getAllCommentsOfPostAPI = createAsyncThunk('page/comments' , async (args , thunkAPI) =>{
    const {rejectWithValue} = thunkAPI ; 
    try{
        const response = await axios.get(getAllCommentsOfPostEndPoint(args) , {
            headers : {
                token : args.token
            }
        })
        return response.data.comments;
    }catch(error){
        return rejectWithValue(error);
    }
})


// For Get Post Of Page Search 
const getPagePostsSearchEndPoint =(args)=> `${DomainName}/page/post?userAccessToken=${args.userToken}&pageId=${args.pageId}`;

export const getPagePostsSearchAPI = createAsyncThunk('extractPagePostsWithId/get' , async(args , thunkAPI)=>{
    const response = await axios.get(getPagePostsSearchEndPoint(args) , {
        headers : {
            token : args.token
        }
    })
    return response.data
})

// For Page Search API
const searchPageEndpoint = (args)=> `${DomainName}/page/searchPage?userAccessToken=${args.userToken}&searchTerm=${args.searchTerm}` ;

export const searchPageAPI = createAsyncThunk('searchPage/getM' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI

    try{
        const response = await axios.get(searchPageEndpoint(args) , {
            headers : {
                token  : args.token
            }
            
        })
        return response.data.searchResults

    }catch(error){
        return rejectWithValue(error)
    }

})

// For Default State
const initialState = {
    data : [] , 
    status : STATUS.IDLE ,
    posts : [] , 
    statusOfPosts : STATUS.IDLE , 
    comments : [] , 
    statusOfComments : STATUS.IDLE , 
    hasNext : ""

}

const ExtractPageSearchSlice = createSlice({
    name : "searchPage" , 
    initialState , 
    reducers : {

    } , extraReducers :(builder)=>{
        builder
        // For Get Search Of Pages
        .addCase(searchPageAPI.fulfilled , (state , action)=>{
            state.data = action.payload ;
            state.status = STATUS.SUCCESS ;
        })
        .addCase(searchPageAPI.pending , (state , action)=>{
            state.status = STATUS.LOADDING ;
        })
        .addCase(searchPageAPI.rejected , (state , action)=>{
            state.status = STATUS.ERROR ;
        })
        // For Get Posts Of Page Search
        .addCase(getPagePostsSearchAPI.fulfilled , (state , action)=>{
            state.statusOfPosts = STATUS.SUCCESS ; 
            state.posts = action.payload.pageDetails.data
            state.hasNext = action.payload.pageDetails.paging.next ? action.payload.pageDetails.paging.cursors.after :""
        })
        .addCase(getPagePostsSearchAPI.pending , (state , action)=>{
            state.statusOfPosts = STATUS.LOADDING ; 
        })
        .addCase(getPagePostsSearchAPI.rejected , (state , action)=>{
            // state.statusOfPosts = STATUS.ERROR ; 
        })
        // For Get All Comments 
        .addCase(getAllCommentsOfPostAPI.fulfilled , (state , action)=>{
            state.comments = action.payload ; 
            state.statusOfComments = STATUS.SUCCESS
        })
        .addCase(getAllCommentsOfPostAPI.pending , (state , action)=>{
            state.statusOfComments = STATUS.LOADDING
        })
        .addCase(getAllCommentsOfPostAPI.rejected , (state , action)=>{
            state.statusOfComments = STATUS.ERROR
        })

        // For Get Next Posts
        .addCase(getNextPostsAPI.fulfilled , (state , action)=>{
            state.posts.push(...action.payload.pageDetails.data);
            state.hasNext = action.payload.pageDetails.paging.next ? action.payload.pageDetails.paging.cursors.after :"" ;
            state.status = STATUS.SUCCESS;
        })
        .addCase(getNextPostsAPI.pending , (state )=>{
            state.status = STATUS.LOADDING ; 
        })
        .addCase(getNextPostsAPI.rejected , (state)=>{
            state.status = STATUS.ERROR ;
        })
    }
})

export default ExtractPageSearchSlice.reducer ; 

export const getSearchPagesResults = state => state.ExtractPageSearchSlice ;

export const getPagePostsSearch = state => state.ExtractPageSearchSlice ;

export const getPageCommentsSearch = state => state.ExtractPageSearchSlice ; 

export const getHasNextSearch = state  => state.ExtractPageSearchSlice.hasNext ;